import { PageIds } from '@hooks/useLayout/types'

/**
 * O nome de cada item do menu vem do endpoint do sidebar. Enquanto o backend não
 * atualizar o `name`, sobrescrevemos apenas o texto exibido — id, path e permissões
 * seguem intactos.
 */
const MENU_LABEL_OVERRIDES: Record<number, string> = {
  [PageIds.CONSUMPTION]: 'Consumo & Bonificação'
}

export const getMenuLabel = (id: number, name: string) => MENU_LABEL_OVERRIDES[id] ?? name
